import type { Release } from "api/dashboardBackend";
import imageGreenLight from "images/greenLight.svg";
import iconInfo from "images/icon-info.svg";
import imageRedLight from "images/redLight.svg";
import imageYellowLight from "images/yellowLight.svg";

export const getReadinessStatus = (release: Release) => {
  const imageStatus =
    release.readinessStatus === "go"
      ? imageGreenLight
      : release.readinessStatus === "wait"
        ? imageYellowLight
        : release.readinessStatus === "stop"
          ? imageRedLight
          : iconInfo;
  const title =
    release.readinessStatus === "go"
      ? "Safe to proceed! "
      : release.readinessStatus === "wait"
        ? "Might be OK to proceed, but check with your #pd- channel first. "
        : release.readinessStatus === "stop"
          ? "Dangerous to proceed! Release should be paused if rolling out already. "
          : "";
  return { imageStatus, title };
};
